import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Typography } from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import BuildRoundedIcon from '@mui/icons-material/BuildRounded';

import LogoWithTitle from '../../assets/images/logo_title.png';

const ACCENT = '#3a54c0';
const ICON_GRADIENT = 'linear-gradient(135deg, #5B6CF5 0%, #9A5CF6 100%)';

// ==============================|| REQUEST TOOL — COMING SOON ||============================== //

const RequestTool = () => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        position: 'relative',
        flexGrow: 1,
        minHeight: '100%',
        overflow: 'hidden',
        backgroundColor: '#0e1525',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {/* ambient glow orbs */}
      <Box
        sx={{
          position: 'absolute',
          top: '-15%',
          left: '50%',
          transform: 'translateX(-50%)',
          width: 620,
          height: 620,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(91,108,245,0.22) 0%, rgba(91,108,245,0) 70%)',
          pointerEvents: 'none'
        }}
      />
      <Box
        sx={{
          position: 'absolute',
          bottom: '-20%',
          right: '-10%',
          width: 520,
          height: 520,
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(154,92,246,0.16) 0%, rgba(154,92,246,0) 70%)',
          pointerEvents: 'none'
        }}
      />

      {/* top bar */}
      <Box sx={{ position: 'relative', zIndex: 2, px: { xs: 3, md: 6 }, py: 3 }}>
        <Box
          component="img"
          src={LogoWithTitle}
          alt="KLOOW"
          onClick={() => navigate('/')}
          sx={{ height: 28, cursor: 'pointer' }}
        />
      </Box>

      {/* centered hero */}
      <Stack
        alignItems="center"
        justifyContent="center"
        spacing={0}
        sx={{ position: 'relative', zIndex: 2, flexGrow: 1, textAlign: 'center', px: 3, pb: 8 }}
      >
        {/* icon badge */}
        <Box
          sx={{
            width: 92,
            height: 92,
            borderRadius: '24px',
            background: ICON_GRADIENT,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0px 24px 60px -12px rgba(91,108,245,0.55)',
            mb: 4
          }}
        >
          <BuildRoundedIcon sx={{ fontSize: 42, color: '#fff' }} />
        </Box>

        {/* coming soon pill */}
        <Stack
          direction="row"
          alignItems="center"
          spacing={1}
          sx={{
            px: 1.75,
            py: 0.75,
            mb: 3,
            borderRadius: '999px',
            backgroundColor: 'rgba(91,108,245,0.12)',
            border: '1px solid rgba(91,108,245,0.35)'
          }}
        >
          <Box
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              backgroundColor: '#7c9cff',
              boxShadow: '0 0 0 0 rgba(124,156,255,0.7)',
              '@keyframes pulse': {
                '0%': { boxShadow: '0 0 0 0 rgba(124,156,255,0.6)' },
                '70%': { boxShadow: '0 0 0 8px rgba(124,156,255,0)' },
                '100%': { boxShadow: '0 0 0 0 rgba(124,156,255,0)' }
              },
              animation: 'pulse 2s infinite'
            }}
          />
          <Typography sx={{ fontSize: 12, fontWeight: 600, letterSpacing: '0.12em', color: '#b9c4ff', textTransform: 'uppercase' }}>
            Coming Soon
          </Typography>
        </Stack>

        {/* heading */}
        <Typography
          sx={{
            fontSize: { xs: 34, md: 48 },
            fontWeight: 700,
            lineHeight: 1.1,
            letterSpacing: '-0.02em',
            color: '#fff',
            mb: 2.5
          }}
        >
          Request a Tool
        </Typography>

        {/* body */}
        <Typography
          sx={{
            maxWidth: 480,
            fontSize: { xs: 15, md: 16 },
            lineHeight: 1.7,
            color: '#8a93a6',
            mb: 5
          }}
        >
          We&apos;re building a place for you to tell us which premium tools to add next. Soon you&apos;ll be able to
          submit requests, vote on what matters most, and watch your wishlist come to life — right from your dashboard.
        </Typography>

        {/* CTA */}
        <Button
          variant="contained"
          disableElevation
          startIcon={<ArrowBackRoundedIcon />}
          onClick={() => navigate('/main/dashboard')}
          sx={{
            textTransform: 'none',
            fontWeight: 600,
            fontSize: 15,
            height: 48,
            px: 3,
            borderRadius: '12px',
            backgroundColor: ACCENT,
            '&:hover': { backgroundColor: '#314aad' }
          }}
        >
          Back to Dashboard
        </Button>
      </Stack>
    </Box>
  );
};

export default RequestTool;
